import {getRequestConfig, request} from "tunnel-commande/src/utils";
import {ServerError, ValidationError} from "../../interfaces";
import {ShopInfo, ShopInfoSchema} from "./ShopRepositorySchemas";
import {isLeft} from "fp-ts/lib/Either";
import reporter from "io-ts-reporters";

export default class ShopRepository {

  public async fetchShopInfo(hostApi: string): Promise<ShopInfo> {
    const result = await request('get',`${hostApi}/shops/infos`, getRequestConfig());

    if(!result.data.shopInfos) {
      throw new ServerError(500, "shop infos unavailable");
    }

    const shopInfo = ShopInfoSchema.decode(result.data.shopInfos);
    if(isLeft(shopInfo)) {
      throw new ValidationError(reporter.report(shopInfo).join('\n\r'));
    }

    return result.data.shopInfos;
  }

  public async fetchColorClass(hostApi: string): Promise<any> {
    const result = await request('get', `${hostApi}/colors-class`, getRequestConfig());
    return result.data.colors;
  }

  public async fetchPriceTable(hostApi: string, productId?: number): Promise<any> {
    const result = await request('post',`${hostApi}/products/calculate-table-price`, {
      ...getRequestConfig(),
      params: { productId }
    });
    return result.data.table;
  }

  public async fetchVideos(hostApi: string): Promise<any[]> {
    const result = await request('get',`${hostApi}/shops/videos`, getRequestConfig());
    return result.data;
  }
}
